var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mu-icon",class:_vm.value,style:({'font-size': _vm.size + 'px', color: _vm.color, fontWeight: _vm.weight? 'bold': 'normal'}),on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }